import { render, staticRenderFns } from "./createGuideBook.vue?vue&type=template&id=cbfdaad6&"
import script from "./createGuideBook.vue?vue&type=script&lang=js&"
export * from "./createGuideBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports